import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  inner: {
    width: '92%', // w-11/12
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.md,
    padding: theme.spacings.sm,
  },
  title: {
    fontSize: theme.fontSizes['3xl'],
    textAlign: 'center',
  },
  startButton: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: theme.spacings.xs,
  },
  startIcon: {
    transform: [{ scale: 1.5 }],
    color: theme.colors.primary,
    fontSize: theme.fontSizes['9xl'],
  },
  startLabel: {
    fontSize: theme.fontSizes['7xl'],
  },
});
